export const APP_VERSION = "0.5.4";
export const APP_NAME = "Noread";

export const WHATS_NEW_FEATURES: { icon: "heart" | "library" | "calendar" | "star"; text: string }[] = [
  { icon: "calendar", text: "Calendrier de lecture : clique sur un jour pour voir ton temps de lecture et les livres lus, retrouve aussi ton objectif annuel au même endroit" },
  { icon: "library", text: "Plusieurs thèmes par livre : associe désormais autant de genres que tu veux à un même livre, depuis l'ajout ou la modification" },
];
